/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Language_NbInputs */

const en_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const es_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const de_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const zh_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const ar_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const fr_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const vi_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const sw_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const th_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const bs_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const ja_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const ko_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const pt_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const it_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const sv_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const nl_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const da_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const nb_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const fi_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const pl_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const ru_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const tr_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const hi_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const id_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const ms_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const cs_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const el_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const he_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const af_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

const hu_nav_language_nb = /** @type {(inputs: Nav_Language_NbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Norsk Bokmål`)
};

/**
* | output |
* | --- |
* | "Norsk Bokmål" |
*
* @param {Nav_Language_NbInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const nav_language_nb = /** @type {((inputs?: Nav_Language_NbInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Language_NbInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_nav_language_nb(inputs)
	if (locale === "de") return de_nav_language_nb(inputs)
	if (locale === "zh") return zh_nav_language_nb(inputs)
	if (locale === "ar") return ar_nav_language_nb(inputs)
	if (locale === "fr") return fr_nav_language_nb(inputs)
	if (locale === "vi") return vi_nav_language_nb(inputs)
	if (locale === "sw") return sw_nav_language_nb(inputs)
	if (locale === "th") return th_nav_language_nb(inputs)
	if (locale === "bs") return bs_nav_language_nb(inputs)
	if (locale === "ja") return ja_nav_language_nb(inputs)
	if (locale === "ko") return ko_nav_language_nb(inputs)
	if (locale === "pt") return pt_nav_language_nb(inputs)
	if (locale === "it") return it_nav_language_nb(inputs)
	if (locale === "sv") return sv_nav_language_nb(inputs)
	if (locale === "nl") return nl_nav_language_nb(inputs)
	if (locale === "da") return da_nav_language_nb(inputs)
	if (locale === "nb") return nb_nav_language_nb(inputs)
	if (locale === "fi") return fi_nav_language_nb(inputs)
	if (locale === "pl") return pl_nav_language_nb(inputs)
	if (locale === "ru") return ru_nav_language_nb(inputs)
	if (locale === "tr") return tr_nav_language_nb(inputs)
	if (locale === "hi") return hi_nav_language_nb(inputs)
	if (locale === "id") return id_nav_language_nb(inputs)
	if (locale === "ms") return ms_nav_language_nb(inputs)
	if (locale === "cs") return cs_nav_language_nb(inputs)
	if (locale === "el") return el_nav_language_nb(inputs)
	if (locale === "he") return he_nav_language_nb(inputs)
	if (locale === "af") return af_nav_language_nb(inputs)
	if (locale === "hu") return hu_nav_language_nb(inputs)
	return en_nav_language_nb(inputs)
});